import * as Yup from 'yup'

import { FACEBOOK_PROVIDER_PLATFORM } from '../../../../../constants/selectLists/platformList'

export const NAME = 'name'
export const ICON = 'icon'
export const ICON_NAME = 'icon_name'

export const DATASETS = 'datasets'
export const EXTERNAL_ID = 'external_id'
export const PROVIDER = 'provider'

export const getInitialValues = (editPartnerAccount = {}) => ({
  [NAME]: editPartnerAccount[NAME] || '',
  [ICON]: editPartnerAccount[ICON] || '',
  [ICON_NAME]: editPartnerAccount[ICON_NAME] || '',

  ...(editPartnerAccount && {
    // datasets are managed in edit form only
    [DATASETS]:
      editPartnerAccount[DATASETS]?.map(account => ({
        value: account[EXTERNAL_ID],
        label: account[NAME]
      })) || [],
    // currently we only support facebook in this form
    [PROVIDER]: FACEBOOK_PROVIDER_PLATFORM
  })
})

export const validationSchema = Yup.object({
  [NAME]: Yup.string().required('Please enter name').max(255, 'Name should have maximum 255 characters'),
  [ICON]: Yup.string().required('Please enter icon image url')
})
